var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{staticStyle:{"width":"100%","height":"100%"},attrs:{"controls":"","preload":"auto","x5-playsinline":"","playsinline":"","webkit-playsinline":""}},[_c('source',{attrs:{"id":"source","src":_vm.Livestreaming,"type":_vm.type}})])}
var staticRenderFns = []

export { render, staticRenderFns }